export enum EAction {
  GET_DOSSIER      = 'GET_DOSSIER',
  SET_DOSSIER      = 'SET_DOSSIER',
  GET_WORKING_LIST = 'GET_WORKING_LIST',
  SET_WORKING_LIST = 'SET_WORKING_LIST',
  GET_QUOTATION    = 'GET_QUOTATION',
  SET_QUOTATION    = 'SET_QUOTATION',
}